import React from 'react'
import useOperation from './use-operation'
import { useObservableBoxValue } from '@morningtrain/react-helpers'

export default function useOperationLoadingState () {
  const operation = useOperation()

  if (!operation) {
    throw new Error('Trying to use operation loading state, but operation is not provided')
  }

  if (!operation.loading) {
    throw new Error('Trying to use operation loading state, but operation.loading is not provided - are you using an updated package version?')
  }

  return useObservableBoxValue(operation.loading)
}
